import React from 'react';
import { useEffect, useState } from 'react';


export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState(0);

    useEffect(() => {
        // inside useEffect, the window is always present
        const updateWindowSize = () => {
            setWindowSize(window.innerWidth);
        };

        updateWindowSize();

        window.addEventListener('resize', updateWindowSize);

        return () => {
            window.removeEventListener('resize', updateWindowSize);
        };
    }, []); // attach this once

    return windowSize;
};